var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"karte-loading-overlay",attrs:{"aria-busy":"true"}},[_c('PageLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }